import { endpointsV3 } from '@/config/api';
import { apiV3 } from '@/lib/api-client';

import type { OrganizationMember } from '../types';

export const listMembers = (): Promise<OrganizationMember[]> => {
  return apiV3.get(endpointsV3.organizationCreators);
};

export const removeMember = (id: string): Promise<void> => {
  return apiV3.delete(`${endpointsV3.organizationCreators}/${id}`);
};

export const removeMembers = async (ids: string[]): Promise<void> => {
  const results = await Promise.allSettled(ids.map(removeMember));
  const rejected = results.find((result) => result.status === 'rejected');
  if (rejected) throw rejected.reason;
};

export const leaveOrganization = (): Promise<void> => {
  return apiV3.post(`${endpointsV3.organization}/leave`);
};
